import FreightForwarderUpdate from '../FreightForwarderUpdate'

const FreightForwarderOverview = ({
    id,
}: { id: number }) => {
    return (
        <FreightForwarderUpdate
            id={id}
            disabled
        />
    )
}

export default FreightForwarderOverview
